module.exports = __webpack_public_path__ + "static/media/logo_white_header.c62a8dab.svg";